
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';


// Use an existing logo file that we know exists in the project
import CoachVaultLogo from '/lovable-uploads/f2df824b-d722-4548-a26c-7d738f754338.png';

export const DashboardHeader: React.FC = () => {
  return (
    <div className="flex items-center justify-between gap-4 mb-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" asChild className="h-8 w-8">
          <Link to="/" aria-label="Back to Home">
            <ArrowLeft className="h-4 w-4" />
          </Link>
        </Button>
        <div className="flex flex-col items-center w-full">
          <div className="flex items-center gap-4">
            <img 
              src={CoachVaultLogo} 
              alt="Coach Vault Logo" 
              className="h-10 w-10"
            />
            <div className="text-center">
              <h1 className="text-3xl font-bold text-[#134E4A]">Coaching Dashboard</h1>
              <p className="text-[#2D7C72]">Track your coaching sessions, clients, and hours</p>
            </div>
          </div>
        </div>
      </div>
      {/* SubscriptionStatus removed: implement status indicator here if needed */}
    </div>
  );
};
